import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useNewCourseRequest = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // POST new course request
  const postData = async (newData) => {
    try {
      const postData = {
        jsStruct: JSON.stringify(newData),
      };
      const response = await axios.post(
        "/NewCourseNewRequestCollection",
        postData
      );
      setData((prevData) => [...prevData, response.data]);
      return response.data;
    } catch (error) {
      console.error("Error adding data:", error);
      throw error;
    }
  };

  // You can add similar methods for update and delete if needed.

  return { data, loading, error, postData };
};

export default useNewCourseRequest;
